(() => {
  const mounted = new WeakSet();
  function mount(scope) {
    scope.querySelectorAll('[data-rnf-collection-page]').forEach(root => {
      if (mounted.has(root)) return;
      mounted.add(root);
      const button = root.querySelector('[data-rnf-filter-toggle]');
      button?.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        button.querySelector('span').textContent = expanded ? button.dataset.hide : button.dataset.show;
        root.classList.toggle('is-filters-hidden', !expanded);
      });
      const count = root.querySelector('#ProductCountDesktop') || root.querySelector('#ProductCount');
      const target = root.querySelector('[data-rnf-grid-count]');
      if (count && target) new MutationObserver(() => { target.textContent = count.textContent.trim(); }).observe(count, {childList:true,subtree:true,characterData:true});
    });
  }
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
